module.exports = __webpack_public_path__ + "a670811f1d13514ea2ce1c154654e57e.MP3";